export default "__VITE_ASSET__c3306937__"